<div class="my-3">
  <button
    mat-raised-button
    class="ms-3"
    routerLink="/evaluator/dashboard/scheduling"
  >
    Back
  </button>
</div>
<mat-card>
  <mat-card-content>
    <h4 style="color: #313131">
      <strong>Application Details</strong>
    </h4>
    <div class="d-flex justify-content-center">
      <mat-chip-list class="mt-3">
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">edit_calendar</mat-icon>
          <div class="d-flex w-100 justify-content-between">
            <div class="d-flex flex-column">
              <span class="text-muted">Schedule:</span>
              <span>
                {{
                  applicationDetails.seminarSchedules[0].seminarDateName | date
                }}
                {{
                  applicationDetails.seminarSchedules[0].timeslot.timeslotName
                }}
              </span>
            </div>
            <div class="d-flex flex-column">
              <span class="text-muted">Attendance:</span>
              <span>
                {{
                  applicationDetails.seminarSchedules[0].isAttended
                    ? "Attended"
                    : "Not Attended"
                }}
              </span>
            </div>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">person</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Full Name:</span>
            <span
              >{{ applicantDetails.firstName }}
              {{ applicantDetails.lastName }}</span
            >
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">mail</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Email Address:</span>
            <span> {{ applicantDetails.email }}</span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">call</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Contact Number:</span>
            <span>{{ applicantDetails.contactNumber }}</span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">work</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Occupation:</span>
            <span>{{ applicationDetails.occupation }}</span>
          </div>
        </mat-chip>
        <mat-chip class="chip mx-1">
          <mat-icon class="me-3 text-success">location_city</mat-icon>
          <div class="d-flex flex-column">
            <span class="text-muted">Establishment:</span>
            <span>{{ applicationDetails.occupationEstablishment }}</span>
          </div>
        </mat-chip>
      </mat-chip-list>
    </div>
    <div class="d-flex justify-content-between mt-3">
      <div>
        <button
          mat-raised-button
          color="secondary"
          [routerLink]="
            '/evaluator/dashboard/application/' +
            applicationDetails.id
          "
        >
          View Application
        </button>
      </div>
      <div>
        <button
          mat-raised-button
          color="primary"
          style="color: white"
          (click)="handleAttendance()"
          *ngIf="!applicationDetails.seminarSchedules[0].isAttended"
          [disabled]="isLoading"
        >
          {{ isLoading ? "Submitting..." : "Mark as Attended" }}
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
